import { render } from "./PassengerDetailsFieldset.vue?vue&type=template&id=37076de7&scoped=true&lang=pug"
import script from "./PassengerDetailsFieldset.vue?vue&type=script&lang=ts"
export * from "./PassengerDetailsFieldset.vue?vue&type=script&lang=ts"

import "./PassengerDetailsFieldset.vue?vue&type=style&index=0&id=37076de7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37076de7"

export default script